<template>
  <div class="employees">
    <v-user-create-update-form v-if="this.isShowModal" @close="closeModal" />
    <div class="row pb-3">
      <div class="col-lg-8">
        <h5>Всего: {{ userList.count }}</h5>
      </div>
      <div class="col-lg-4 text-center">
        <button class="btn-primary" @click="showModal">Добавить сотрудника</button>
      </div>
    </div>
    <div v-if="this.loading" class="col-lg-9">
      <div class="d-flex justify-content-center">
        <div class="spinner-grow m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-else>
      <v-user-table :user-list="this.userList"
                    @update="closeModal" @close="closeModal" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import VUserTable from '../../components/tables/v-user-table.vue';
import VUserCreateUpdateForm from '../../components/forms/v-user-create-update-form.vue';

export default {
  name: 'Employees',
  components: { VUserCreateUpdateForm, VUserTable },
  computed: {
    ...mapState('user', ['userList']),
  },
  data() {
    return {
      isShowModal: false,
      loading: true,
    };
  },
  methods: {
    ...mapActions('user', ['getUserList']),
    showModal() {
      this.isShowModal = true;
    },
    closeModal() {
      this.isShowModal = false;
      this.loading = true;
      this.getUserList('?role=employee')
        .then(() => { this.loading = false; });
    },
  },
  mounted() {
    this.getUserList('?role=employee')
      .then(() => { this.loading = false; });
  },
};
</script>
